import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { buildEngineStates, getEngineVoltageDifference } from './engine-state.utils';

@Component({
  selector: 'app-voltage-speed-engine-state',
  templateUrl: './engine-state.component.html',
  styleUrls: ['./engine-state.component.css']
})
export class VoltageSpeedEngineStateComponent implements OnChanges {
  @Input() summary: VoltageSpeedDashboardSummary | null = null;

  states = buildEngineStates(null);
  voltageDifference: number | null = null;

  ngOnChanges(): void {
    this.states = buildEngineStates(this.summary);
    this.voltageDifference = getEngineVoltageDifference(this.summary);
  }
}
